module.exports = __webpack_public_path__ + "img/avatar7.c8fefab3.png";